import { OfficeOnlineViewerComponent } from './components/officeOnlineViewer/officeOnlineViewer';
import { ErrorDialog } from './components/errorDialog/errorDialog';
import { LaunchDialog } from './components/launchDialog/launchDialog';
import { componentsModule as ShareBaseComponents } from 'sharebase/components';
import { servicesModule as ShareBaseServices } from 'sharebase/services'

export const OfficeOnlineModule = angular
	.module('wopi.officeOnlineViewer', [
		ShareBaseComponents.name,
		ShareBaseServices.name
	])
	.component('wopiViewer', OfficeOnlineViewerComponent)
	.service('wopiLaunchDialog', LaunchDialog)
	.service('wopiErrorDialog', ErrorDialog);



// WEBPACK FOOTER //
// ./src/office-online/index.ts